import React from 'react'
import { Navbar, Footer } from "../../components"
import { ClientLogin } from "../Login"
export default function Login() {
  return (
    <div className='emas__login'>
        <Navbar />
        <ClientLogin />
        <Footer />
    </div>
  )
}
